// extracted by mini-css-extract-plugin
export default {"tabBar":"MainLayout_tabBar__WKLGV","sideBar":"MainLayout_sideBar__Mcv6h","headerMenu":"MainLayout_headerMenu__zCAyQ"};